import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { defaultThemeStyles } from './catalog__breadcrumbs.theme'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const breadcrumbsStyles: IStyles = {
    breadcrumbsWrapper: {
        //display: 'none'
        background: 'none !important',
        //backgroundColor: `var(--var-module-catalog-component-breadcrumbs-style-background, ${defaultThemeStyles.background})`,
    },
    contentScroll: {
        ...item.overX,
        ...grid.row,
        ...grid.noWrap,
        maxWidth: '100%',
    },
    itemWrapper: {
        ...grid.row,
        ...grid.noWrap,
    },
    item: {
        ...grid.rowCenter,
        ...grid.noWrap,
        ...grid.pl_microPlus,
        ...grid.pr_microPlus,
        ...item.pointer,
        textDecoration: 'none',
        color: `var(--var-module-catalog-component-breadcrumbs-style-textMain, ${defaultThemeStyles.textMain})`,
        '&:hover': {
            color: `var(--var-module-catalog-component-breadcrumbs-style-hover, ${defaultThemeStyles.hover})`,
            '& .home_icon': {
                color: `var(--var-module-catalog-component-breadcrumbs-style-hover, ${defaultThemeStyles.hover})!important`,
            },
            '& .group_files_icon': {
                color: `var(--var-module-catalog-component-breadcrumbs-style-hover, ${defaultThemeStyles.hover})!important`,
            },
        },
    },
    active: {
        color: `var(--var-module-catalog-component-breadcrumbs-style-active, ${defaultThemeStyles.active})`,
        cursor: 'default',
        '&:hover': {
            color: `var(--var-module-catalog-component-breadcrumbs-style-hover, ${defaultThemeStyles.hover})!important`,
        },
        '& .home_icon': {
            color: `var(--var-module-catalog-component-breadcrumbs-style-active, ${defaultThemeStyles.active})!important`,
            cursor: 'default',
        },
        '& .group_files_icon': {
            color: `var(--var-module-catalog-component-breadcrumbs-style-active, ${defaultThemeStyles.active})!important`,
            cursor: 'default',
        },
    },
    itemDropActive: {
        color: `var(--var-module-catalog-component-breadcrumbs-style-drop, ${defaultThemeStyles.drop})`,
        //backgroundColor: `var(--var-module-catalog-component-breadcrumbs-style-dropBackground, ${defaultThemeStyles.dropBackground})`,
        '& .home_icon': {
            color: `var(--var-module-catalog-component-breadcrumbs-style-drop, ${defaultThemeStyles.drop})!important`,
        },
        '& .group_files_icon': {
            color: `var(--var-module-catalog-component-breadcrumbs-style-drop, ${defaultThemeStyles.drop})!important`,
        },
    },
    indents: {
        ...grid.pt_md,
        ...grid.pb_md,
    },
    itemArrow: {
        cursor: 'default',
        '& .breadcrumbs__arrow': {
            cursor: 'default',
        },
    },
    text: {
        ...grid.rowCenter,
        textTransform: 'uppercase',
        fontSize: textSizes.normal,
        textDecoration: 'none',
        whiteSpace: 'nowrap',
    },
}

addStyles(breadcrumbsStyles)
export default breadcrumbsStyles
